import GenericHead from 'components/GenericHead';
import { getSiteUrl } from 'state/Config/selectors';
import { Helmet } from 'react-helmet';
import { parse as parseUrl, resolve as resolveUrl } from 'url';
import { useSelector } from 'react-redux';

type Props = {
  ampEnabled: boolean;
  canonical: string;
  description: string;
  image: string;
  isBranded: boolean;
  seoTitle: string;
  slug: string;
  socialTitle: string;
  title: string;
};

function ArticleHead({
  ampEnabled,
  canonical,
  description,
  image,
  isBranded = false,
  seoTitle,
  slug,
  socialTitle,
  title = '',
}: Props) {
  const siteUrl = useSelector(getSiteUrl);

  const keywords = title
    .toLowerCase()
    .split(' ')
    .filter(word => word.match(/\w+/gi))
    .join(', ');

  const canonicalMatchesSiteUrl =
    canonical && parseUrl(canonical).host === parseUrl(siteUrl).host;

  // eslint-disable-next-line global-require
  const twitter = require('raw-loader!vendor/twitter');

  return (
    <div>
      <GenericHead
        description={`${description} ${
          isBranded ? '[Sponsored Content] ' : ''
        }| iHeart`}
        image={image}
        noAltLink
        ogType="article"
        socialTitle={socialTitle}
        title={seoTitle}
        twitterCard="summary_large_image"
      />
      <Helmet
        link={[
          ...(ampEnabled && canonicalMatchesSiteUrl ?
            [
              {
                href: resolveUrl(siteUrl, `/alternate/amp/${slug}/`),
                rel: 'amphtml',
              },
            ]
          : []),
          { href: canonical, rel: 'canonical' },
        ]}
        meta={
          [
            { content: `${title}, ${keywords}`, name: 'keywords' },
            { content: image, name: 'twitter:image:src' },
            ...(isBranded ? [{ content: 'noindex', name: 'taboolabot' }] : []),
          ] as Array<{ content: string; name: string }>
        }
        script={[
          {
            innerHTML: twitter.default ?? twitter,
            type: 'text/javascript',
          },
        ]}
      />
    </div>
  );
}

export default ArticleHead;
